import React, {useEffect, useContext} from 'react'
import styled from 'styled-components';
import { GoogleMap} from '@react-google-maps/api'
import { mapDefault } from './mapUtils';
import LayersMenu, { MAP_ROAD } from './LayersMenu';
import ButtonFullScreen from './ButtonFullscreen';
import GoogleMapsProvider, { GoogleMapsContext, GoogleMapsContextProps } from './GoogleMapsProvider';

const Map = ({onLoad, zoom = 15, initialMapType = MAP_ROAD, center, children}) => {
    return  <Container>
      <GoogleMap id="map" options={mapDefault} onLoad={onLoad} zoom={+zoom} center={center}>                
        <WrapperActions>
            <div>
                <LayersMenu/>
            </div>
            
            <div className='wrap-item'>
                <ButtonFullScreen />
            </div>
        </WrapperActions>
        
        {children}
      </GoogleMap> 
    </Container>
  }

export default React.memo(Map)

const Container = styled.div`
  width: 100%;
  height: 100%;

  #map{
      width: 100%;
      height: 100%;
  }
`


const WrapperActions = styled.div`
    top: 24px;
    right: 14px;    
    z-index: 1;
    display: flex;
    flex-wrap: wrap;
    position: absolute;
    padding-left: 10px;
    justify-content: end;

    .wrap-item{
        display: flex;
        flex-basis: 100%;
        margin-top: 15px;
        justify-content: end;
        position: absolute;
        top: 49px;
    }
`




